/**
 * MOCK KORA record-type list (records-request.md: Category is reused as the record-type taxonomy,
 * Kind="kora" — SAME entity pattern as question topics / channels). Mirrors questionTopics.ts's
 * shape/role.
 *
 * USE_MOCKS-fallback only — every live-aware surface reads record types from the real Kind=kora
 * Category entities instead: the resident RecordsRequestPage via ThemeProvider's `koraRecordTypes`
 * (fed by GET /api/public/embed-config, server-split by Kind); staff surfaces (KORADetailPage,
 * CategoriesAdmin's KORA tab) via a live admin/embed read. This mock list is the last-resort
 * fallback if a live fetch returns an empty list (a brand-new tenant with no KORA record types
 * configured yet) — never imported directly by a resident/staff page.
 */
export interface KORARecordType {
  id: string;
  label: string;
}

export const MOCK_KORA_RECORD_TYPES: KORARecordType[] = [
  { id: "police-reports", label: "Police reports / incident records" },
  { id: "meeting-minutes", label: "Council meeting minutes & agendas" },
  { id: "permits-licenses", label: "Permits & licenses" },
  { id: "financial-records", label: "Financial records / budgets" },
  { id: "correspondence", label: "Correspondence / emails" },
  { id: "other", label: "Something else" },
];
